import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SideNav from "../../components/customComponents/sideNav/SideNav";
import { manufacturerNavigations, brandNavigations } from "../../NavigationData";
import { isBrandRole } from "../../utils/userRole";
import { getBrandProfile, getManufacturerProfile, getUnreadNotificationCount } from "../../store/actions";
import styles from "./adminDashboard.module.scss";

export default function AdminDashboard() {
  const dispatch = useDispatch();
  const loginUser = useSelector((state) => state.auth?.loginUser);
  const isBrand = isBrandRole(loginUser);

  useEffect(() => {
    dispatch(isBrand ? getBrandProfile() : getManufacturerProfile());
    dispatch(getUnreadNotificationCount());
  }, [dispatch, isBrand]);

  return (
    <div className={styles.container}>
      <SideNav
        navigations={isBrand ? brandNavigations : manufacturerNavigations}
        navTheme={isBrand ? "brand" : "manufacturer"}
      />

      <div className={styles.content}>
        <Outlet />
      </div>
    </div>
  );
}
